module.exports = __webpack_public_path__ + "img/nav-dashboards.620bd9d4.svg";